var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkjerming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "48px",
    viewBox: "-10 -10 89 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.25,17.2941176 C23.6012746,17.2941176 29.3512746,14.4117647 34.5,8.64705882 C29.3512746,2.88235294 23.6012746,0 17.25,0 C10.8987254,0 5.14872538,2.88235294 0,8.64705882 C5.14872538,14.4117647 10.8987254,17.2941176 17.25,17.2941176 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "For-familiemedlem---nyeste-versjon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Personopplysninger",
    transform: "translate(-115.000000, -1348.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(115.000000, 1348.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "skjerming2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5,0 C60.6756373,0 63.25,2.58094674 63.25,5.76470588 L63.25,37.4705882 C63.25,40.6543474 60.6756373,43.2352941 57.5,43.2352941 L11.5,43.2352941 C8.32436269,43.2352941 5.75,40.6543474 5.75,37.4705882 L5.75,5.76470588 C5.75,2.58094674 8.32436269,0 11.5,0 L57.5,0 Z",
    id: "Path",
    fill: "#59514B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E3B0A8",
    fillRule: "nonzero",
    points: "58.9375 4.32352941 10.0625 4.32352941 10.0625 38.9117647 58.9375 38.9117647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,41.8661765 C69,45.0499356 66.4256373,47.6308824 63.25,47.6308824 L5.75,47.6308824 C2.57436269,47.6308824 0,45.0499356 0,41.8661765 L69,41.8661765 Z",
    id: "Path",
    fill: "#3E3832",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(17.250000, 12.970588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25,17.2941176 C23.6012746,17.2941176 29.3512746,14.4117647 34.5,8.64705882 C29.3512746,2.88235294 23.6012746,0 17.25,0 C10.8987254,0 5.14872538,2.88235294 0,8.64705882 C5.14872538,14.4117647 10.8987254,17.2941176 17.25,17.2941176 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5EAEC7",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    cx: 17.25,
    cy: 8.64705882,
    rx: 7.1875,
    ry: 7.20588235
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3E3832",
    fillRule: "nonzero",
    transform: "translate(34.500000, 22.338235) rotate(45.000000) translate(-34.500000, -22.338235) ",
    points: "33.0376838 4.34466912 35.9163603 4.34834559 35.9623162 40.3318015 33.0836397 40.328125"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#FFFFFF",
    cx: 30,
    cy: 19,
    r: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkjerming);
export default __webpack_public_path__ + "static/media/Skjerming.80e1db7e8be0fd46a9eb52d118185fbc.svg";
export { ForwardRef as ReactComponent };